export default __webpack_public_path__ + "static/media/Page6.2592ef4e.txt";